import { render, staticRenderFns } from "./ReferralCode.vue?vue&type=template&id=f605088a&scoped=true&"
import script from "./ReferralCode.vue?vue&type=script&lang=js&"
export * from "./ReferralCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f605088a",
  null
  
)

export default component.exports